(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/play/assets/javascripts/views/single-rows-container.js') >= 0) return;  svs.modules.push('/modules/keno/components/play/assets/javascripts/views/single-rows-container.js');

'use strict';

svs.keno.components.play.views.SingleRowsContainer = Marionette.View.extend({
  className: 'numbergames-play-content padding-xs-h-1 padding-xs-bottom-2 padding-md-bottom-0 padding-md-h-2',
  regions: {
    boardSettingsRegion: '#boardSettingsRegion',
    boardContainerRegion: '#boardContainerRegion',
    rowsRegion: '#rowsRegion',
    campaignCardRegion: '#campaignCardRegion'
  },
  template(data) {
    return svs.keno.components.play.templates.single_rows_container(data);
  },
  onRender() {
    this.showChildView('boardSettingsRegion', new svs.keno.components.play.views.BoardSettings({
      model: this.model,
      collapsedToggleWidth: 180
    }));
    this.showChildView('boardContainerRegion', new svs.numbergames.game.views.BoardContainer({
      model: this.model,
      className: 'col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-lg-5 col-md-offset-1 col-lg-offset-2'
    }));
    this.showChildView('rowsRegion', new svs.numbergames.game.views.SingleRowsContainer({
      model: this.model,
      ballRowSize: svs.core.detect.breakpoint.greaterThan('xs') ? 200 : 150
    }));
    this.showChildView('campaignCardRegion', new svs.numbergames.game.views.CampaignCard({
      model: this.model,
      className: 'col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4'
    }));
  }
});

 })(window);